import { useBrowser } from '@/utils/generalUtils.ts'

export default function (el, binding) {
  const { isFirefox } = useBrowser()

  const value = (isFirefox && binding.value === 'plaintext-only') || binding.value

  el.setAttribute('contenteditable', value)
}
